<template>
	<div class="mb-3 col-sm-6 col-md-4 item" :class="{'list-group-item': displayList}">
		<div class="thumbnail card">
			<div class="img-event intrinsic">
				<img :src="require(`@/assets/images/${item.thumbnail_url}.png`)" alt=""
				     class="grow thumbnail-image card-img-top intrinsic-item p-3">
			</div>
			<div class="card-body">
				<router-link :to="'/product/' + item.id" tag="h5" class="card-title"><a>{{ item.title }}</a>
				</router-link>
				<p class="card-text truncate">{{ item.description | shortDescription }}</p>

				<div class="row">
					<p class="col-6 lead">{{ token }} IDT</p>
					<p class="col-6">
						<button class="btn btn-success pull-right" :disabled="item.quantity === 0" @click="detailsSinger">
							Support
						</button>
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapActions
	} from 'vuex';
	import { accountGetInfo } from "@/service/accountInfo";
	import { notifyError } from "@/utils";

	export default {
		data() {
			return {
				tokenRelationships: {}
			}
		},
		computed: {
			token() {
				if(this.tokenRelationships[0]) {
					return this.tokenRelationships[0].balance;
				} else {
					return 0;
				}
			}
		},
		props: ['item', 'displayList'],
		methods: {
			...mapActions(['updateCart']),
			addItem() {
				const order = {
					item: Object.assign({}, this.item),
					quantity: 1,
					isAdd: true
				};
				this.updateCart(order);
			},
			detailsSinger() {
				if(this.$store.getters.getCurrentAccount.accountId) {
					this.$store.commit('setSinger', this.item);
					this.$router.push({name: 'singerDetails'});
				} else {
					notifyError('Sign in with user account');
				}
			},
			async getTokens() {
				const resultTokens = [];
				const tokenRelationships = await accountGetInfo(this.item.accountId);
				for (const key in tokenRelationships) {
					const tokenRelationship = tokenRelationships[key];
					resultTokens.push(tokenRelationship);
				}
				this.tokenRelationships = resultTokens;
			},
		},
		filters: {
			shortDescription(value) {
				if (value && value.length > 100) {
					return value.substring(0, 100) + '...';
				} else {
					return value;
				}
			}
		},
		created() {
			console.log('ProductItem.vue created');
			console.log(this.item);
			this.getTokens();
		}
	}
</script>

<style lang="scss" scoped>
	div.card {
		height: 100%;
	}

	.card-text {
		font-size: 0.875rem;
	}

	.remain {
		color: #d17581;
	}

	.grow {
		transition: all .2s ease-in-out;
	}

	.grow:hover {
		transform: scale(1.1);
	}

	.list-group-item {
		float: none;
		width: 100%;
		background-color: #fff;
		margin-bottom: 30px;
		-ms-flex: 0 0 100%;
		flex: 0 0 100%;
		max-width: 100%;
		padding: 0 1rem;
		border: 0;

		.thumbnail {
			display: inline-block;
			width: 100%;
		}

		.img-event {
			width: 20%;
			float: left;
			padding: 0 !important;
			margin: 0;
			height: auto;
		}

		.thumbnail-image {
			position: static;
		}

		.card-body {
			float: left;
			width: 80%;
			margin: 0;
		}

		@media (max-width: 767.98px) {
			.img-event {
				width: 30%;
				float: left;
				padding: 0 !important;
				margin: 0;
			}

			.card-body {
				float: left;
				width: 70%;
				margin: 0;
			}
		}
	}


	.item.list-group-item:before, .item.list-group-item:after {
		display: table;
		content: " ";
	}

	.item.list-group-item:after {
		clear: both;
	}
</style>
